<template>
    <!-- https://tailwindui.com/components/application-ui/lists/grid-lists#component-5d72b187beb968e12db89fe49f272b18 -->
    <li class="flex flex-col col-span-1 text-center bg-white rounded-lg shadow">
        <div class="flex flex-col flex-1 px-8 py-4">
            <div class="text-center">
                <floating-input     :id="'zone_name_' + zone.ID"
                                    v-model:value="name"
                                    label="Zone Name"
                                    :centered="true"
                ></floating-input>
            </div>
            <div class="m-2">
                <span class="text-sm text-gray-500">Groups that view {{ groupAlarmingEnabled ? '& receive alarms on' : '' }} <i>{{name}}</i></span>
                <div v-if="errorEmptyGroups">
                    <span class="text-sm text-red-500">
                        Cannot have a zone with no groups.
                    </span>
                </div>

                <select2 :options='groups'
                         :multiple="true"
                         v-model:value="groupsSelected"
                         placeholder="Add Groups"
                         class=""
                ></select2>
            </div>
        </div>
        <div class="border-t border-gray-200">
            <div class="flex -mt-px">
                <div class="flex flex-1 w-0 border-r border-gray-200">
                    <div    v-if="errorSaving" class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-br-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10"
                            @click="save"
                    >
                        <span class="lnr icon-floppy-disk"></span>
                        <span class="ml-3 text-red-600">Error Saving</span>
                    </div>
                    <div v-else-if="zone.needsSaved"
                         @click="save"
                         class="relative inline-flex items-center justify-center flex-1 w-0 py-4 -mr-px text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-bl-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-floppy-disk"></span>
                        <span class="ml-3">Save</span>
                    </div>
                    <div v-else class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-br-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-check"></span>
                        <span class="ml-3">Saved</span>
                    </div>
                </div>
                <div class="flex flex-1 w-0 -ml-px">
                    <div    v-if="errorDeleting"
                            @click="deleteZone"
                            class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-br-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-cross2"></span>
                        <span class="ml-3 text-red-600">Error Removing</span>
                    </div>
                    <div    v-else
                            @click="deleteZone"
                            class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-br-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-cross2"></span>
                        <span class="ml-3">Remove</span>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    import Select2 from "@/components/elements/select2";
    import axios from "axios";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    export default {
        name: "InstallWizardLayoutCard",
        components: {Select2},
        mixins: [SonicuCoreMixin],
        props: {
            zoneProp: Object,
            groups: Object,
            zoneIndex: Number,
            areaIndex: Number,
            groupAlarmingEnabled: Boolean,
        },
        data(){
            return{
                zone: this.zoneProp,
                name: this.zoneProp.Name,
                groupsSelected: this.getGroupArray(),
                errorEmptyGroups: false,
                errorSaving: false,
                errorDeleting: false,
            }
        },
        mounted() {
        },
        methods: {
            save(){
                if(_.isNil(this.zone.ID)){
                    this.createZone();
                } else {
                    this.updateZone();
                }
            },
            createZone(){
                axios
                    .post(this.company.buildCompanyApiInternalRoute('wizard/areas/'+String(this.zone.AreaID)+'/zones/'),
                        {zoneName: this.name, groups: this.groupsSelected})
                    .then(response => {
                        this.zone.needsSaved = false;
                        this.zone = response.data;
                        this.emitSaved();
                    });
            },
            updateZone(){
                this.errorSaving = false
                axios
                    .put(this.company.buildCompanyApiInternalRoute('wizard/areas/'+String(this.zone.AreaID)+'/zones/'+String(this.zone.ID)+'/edit'),
                        {zoneName: this.name, groups: this.groupsSelected})
                    .then(response => {
                        this.zone.needsSaved = false;
                        this.zone = response.data;
                        this.emitSaved();
                    }).catch(error => {
                        this.errorSaving = true
                    });
            },
            deleteZone(){
                this.errorDeleting = false
                if(this.zone.ID === undefined){
                    this.$emit('deleted', this.areaIndex, this.zoneIndex);
                } else {
                    axios
                        .delete(this.company.buildCompanyApiInternalRoute('wizard/areas/'+String(this.zone.AreaID)+'/zones/'+String(this.zone.ID)+''),
                            {})
                        .then(response => {
                            this.zone.needsSaved = false;
                            this.$emit('deleted', this.areaIndex, this.zoneIndex);
                        }).catch(error => {
                            this.errorDeleting = true
                        });
                }
            },
            getGroupArray(){
                let groups = []
                _.each(this.zoneProp.groups, item => {
                    groups.push(item.ID)
                })
                return groups
            },
            emitSaved(){
                this.$emit('saved', this.zone, this.zoneIndex);
            }
        },
        computed: {
        },
        watch: {
            name(val) {
              this.zone['needsSaved'] = true
              this.zone['Name'] = val
                this.$emit('needs-saved');
            },
          groupsSelected: {
            handler(val, old) {
              if (val.length === 0) {
                this.errorEmptyGroups = true
                setTimeout(() => {
                  // Set the group to Default
                  this.groupsSelected = ['1']
                }, 150)
                return
              }
              this.zone.needsSaved = true;
              this.$emit('needs-saved', this.zone);
            }, deep: true
          }
        }
    }
</script>

<style scoped>

</style>
